<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M12.5 2.34375C6.89086 2.34375 2.34375 6.89086 2.34375 12.5C2.34375 18.1091 6.89086 22.6562 12.5 22.6562C18.1091 22.6562 22.6562 18.1091 22.6562 12.5C22.6562 6.89086 18.1091 2.34375 12.5 2.34375ZM13.2812 6.25C13.2812 5.81853 12.9315 5.46875 12.5 5.46875C12.0685 5.46875 11.7188 5.81853 11.7188 6.25V12.5C11.7188 12.9315 12.0685 13.2812 12.5 13.2812H17.1875C17.619 13.2812 17.9688 12.9315 17.9688 12.5C17.9688 12.0685 17.619 11.7188 17.1875 11.7188H13.2812V6.25Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgClock',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>